import { render } from "./daytwo-grid.vue?vue&type=template&id=63436aca"
import script from "./daytwo-grid.vue?vue&type=script&lang=js"
export * from "./daytwo-grid.vue?vue&type=script&lang=js"

import "./daytwo-grid.vue?vue&type=style&index=0&id=63436aca&lang=scss"
script.render = render

export default script